import axios from 'axios'
import {useQuery} from 'react-query'
import { API_URL } from 'src/cms/constants/EndPoint'

const QUERY_KEY = 'getRoleOptions'

export const useGetRoleOptions = () => {
  return useQuery(
    [QUERY_KEY],
    async () => {
      const {data} = await axios.get(`${API_URL}/role/list`, {
        headers: {
          'accept': 'application/json',
        },
      })

      // Map to { label, value } format if needed for UI components
      return data.data.role.map((role: any) => ({
        label: role.name,
        value: role.id,
      }))
    },
    {
      onError: (error) => {
        console.error('Error fetching roles:', error)
      },
    }
  )
}
